import { web2app } from '@kcd/app-interface';

import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

import { registerMembership } from '../utils';

/**
 * @description 멤버십 가입 페이지를 바로 여는 hook
 * */
export const useRegisterMembership = () => {
  const { businessId } = useBusinessIdStore();
  return (queryString?: string) => registerMembership(businessId, queryString);
};

/**
 * @description 멤버십 가입 다이얼로그를 열고, 확인시 가입페이지를 열어주는 hook
 * */
export const useRegisterMembershipDialog = () => {
  const register = useRegisterMembership();

  async function openRegisterMembershipDialog(queryString?: string) {
    const { confirmed } = await web2app.openDialogAsync({
      type: 'confirm',
      title: '첫달 무료\n멤버십 가입하고 구매하기',
      description: '매월 6만원 쿠폰 지급됩니다.',
      confirmText: '확인',
      cancelText: '취소',
    });

    if (confirmed) {
      void register(queryString);
    }
  }

  return openRegisterMembershipDialog;
};
